import { render, staticRenderFns } from "./NoticeBox.vue?vue&type=template&id=29be176e&scoped=true&"
import script from "./NoticeBox.vue?vue&type=script&lang=js&"
export * from "./NoticeBox.vue?vue&type=script&lang=js&"
import style0 from "./NoticeBox.vue?vue&type=style&index=0&id=29be176e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29be176e",
  null
  
)

export default component.exports